import {
  GET_USER,
  CHANGE_TOWN,
  CLEAR_USER,
  GET_ORDER_ADDRESS,
  EDITING_ADDRESS
} from './mutation-types'

export default {
    [GET_USER] (state,user) {
      state.user = user
      
      },
      [CHANGE_TOWN] (state,townStreet) {
        state.townStreet = townStreet
        
        },
    [CLEAR_USER] (state) {
      state.user = {}
      
      },
      [GET_ORDER_ADDRESS] (state,orderAddress) {
        state.orderAddress = orderAddress
        
        },
        [EDITING_ADDRESS] (state,editingAddress) {
          state.editingAddress = editingAddress
          
          }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js